// /live's Join the Meeting dialog (ModalDialog/JoinMeeting.vue, Video/Link.vue; Seán,
// 2026-11-03): in a visit, it opens as the first session after check-in starts (the event
// proper), or on arriving while a later session is live; never at check-in (Seán: the meeting
// hasn't begun), at most twice, and never once its meeting has been joined. Not at later
// sessions, nor after the break: those who joined stay in the one Zoom meeting.
import {authFetch} from "@/composables/useAuthFetch";

const MAX_OPENS = 2;
const openCounts = new Map();
const joinedEvents = new Set();
const seenLive = new Set();

// isOpening: the session going live is the first after check-in; isCheckIn: it's check-in
export function getIsDialogDue(eventName, isOpening, isCheckIn) {
  if (isCheckIn) return false;
  const isFirstSeen = !seenLive.has(eventName);
  seenLive.add(eventName);
  if (joinedEvents.has(eventName)) return false;
  if ((openCounts.get(eventName) || 0) >= MAX_OPENS) return false;
  return isFirstSeen || Boolean(isOpening);
}

export function markDialogOpened(eventName) {
  openCounts.set(eventName, (openCounts.get(eventName) || 0) + 1);
}

// "Masterclass 2026" → "masterclass-2026"; the Workshop's ("VIZBI 2026") → "workshop-2026"
function getEventKey(eventName) {
  const kind = String(eventName).startsWith("Masterclass") ? "masterclass" : "workshop";
  return `${kind}-${String(eventName).match(/\d{4}/)?.[0]}`;
}

// the server notes the account's first join (fullstack user/joined.post.js), which lists it in
// the event's attendee directory; never awaited, so Zoom's tab isn't held up or blocked
function postJoined(eventName) {
  const body = JSON.stringify({event: getEventKey(eventName)});
  const options = {method: "POST", headers: {"Content-Type": "application/json"}, body,
    keepalive: true};
  authFetch("/api/v1/user/joined", options).catch((error) => {
    console.warn("joined: not recorded", error?.message);
  });
}

export function markJoined(eventName) {
  joinedEvents.add(eventName);
  postJoined(eventName);
}

// test mode's Run test and Reset (LiveEvent.vue): each run starts as a new visit
export function resetLiveMeeting() {
  [openCounts, joinedEvents, seenLive].forEach((collection) => collection.clear());
}
